import DataLayerManager from "../trackers/dataLayer/dataLayerManager";
import SearcherManager from "./searcherManager";

export default class SearchManager {
    constructor() {
        this.dataLayerManager = new DataLayerManager();
        this.eventDelegation();
    }

    eventDelegation() {
        $("body").on("click", "[data-searcher-chollo]", (event) => {
            this.createBooking($(event.currentTarget));
        });

        document.querySelectorAll('[data-searcher-subchollo]').forEach((element) => {
            element.addEventListener('click', (event) => {
                this.createSubcholloBooking($(event.currentTarget));
            });
        })
    };

    createBooking(elem) {
        let cholloId = elem.data('chollo-id');
        let cholloDateId = elem.data('date-id');
        $('#searcher-form [data-form-input="id-chollo"]').val(cholloId);
        $('#searcher-form [data-form-input="id-date"]').val(cholloDateId);

        if (typeof elem.data('chollo-only-adults') != 'undefined') {
            $('#searcher-form [data-form-input="people"]').val(parseInt($('[name="' + SearcherManager.inputs.adults + '"]').val()) + parseInt($('[name="' + SearcherManager.inputs.children + '"]').val()));
        } else {
            $('#searcher-form [data-form-input="people"]').val($('[name="' + SearcherManager.inputs.adults + '"]').val());
        }

        let datalayerParameters = {
            'cholloId': cholloId,
            'cholloDateId': cholloDateId,
            'numOfPeople': $('[data-form-input="people"]').val(),
            'step': 2,
            'checkoutType': 'search'
        };

        this.dataLayerManager.push(DataLayerManager.prototype.type_checkout, datalayerParameters);
        $('#searcher-form').attr('target', '_blank').submit();
    }

    createSubcholloBooking(elem) {
        let cholloId = elem.data('chollo-id');
        let cholloDateId = elem.data('date-id');
        let numOfPeople = elem.data('num-of-people');
        if (cholloId && cholloDateId && numOfPeople) {
            let datalayerParameters = {
                'cholloId': cholloId,
                'cholloDateId': cholloDateId,
                'numOfPeople': numOfPeople,
                'step': 2,
                'checkoutType': 'search'
            };

            this.dataLayerManager.push(DataLayerManager.prototype.type_checkout, datalayerParameters);
        }
    }
}
